export default __webpack_public_path__ + "static/media/art_cropped.6b680856.png";